import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Menu } from '@headlessui/react';
import 'react-activity/lib/Spinner/Spinner.css';
import NotificationPopUp from '../common/NotificationPopup';
import { notificationCount } from '../../action/AdminAction';
import { PATH } from '../../../utils/Constants';
// import profileImg from "../../../utils/images/profileImg.png";
import { logOutUser, logout, getUserInformation } from '../../action/UserAction';
import { showNotification } from '../../action/NotificationAction';
import { Consumer } from '../../../utils/common/NamingTerms';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import LogoutConfirmation from './LogoutConfirmation';

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class Header extends Component {
    static propTypes = {
        title: PropTypes.string,
        logOutUser: PropTypes.func,
        showNotification: PropTypes.func,
        getUserInformation: PropTypes.any,
        history: PropTypes.any,
        userDetails: PropTypes.any,
        name: PropTypes.any,
        match: PropTypes.any,
    };

    constructor(props) {
        super(props);
        this.state = {
            isLogout: false,
            notificationCount: 0,
            showLogoutConfirmation: false,
        };
        this.handleConfirmLogout = this.handleConfirmLogout.bind(this);
        this.handleCancelLogout = this.handleCancelLogout.bind(this);
        this.inkoveSignOut = this.inkoveSignOut.bind(this);
    }

    /**
     * @inheritDoc
     */
    componentDidMount() {
        this.getnotificationCount();
        this.props.getUserInformation((res) => {
            if (res && res.response && res.response.name) {
                document.title = `${res?.response?.name} || ${this.props.title}`;
            } else {
                document.title = `${Consumer} || ${this.props.title}`;
            }
        });
    }

    /**
     * Disable Login button
     */
    disableLogin() {
        this.setState({ isLogout: !this.state.isLogout });
    }

    // getnotificationCount
    getnotificationCount() {
        this.props.notificationCount((reponse) => {
            if (reponse) {
                if (reponse.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    this.setState({ notificationCount: reponse.response.unread });
                } else {
                    this.props.showNotification(reponse.message, RESPONSE_CONSTANT.ERROR);
                    return;
                }
            }
        });
    }

    /**
     * handle invoke signout
     */
    inkoveSignOut() {
        this.disableLogin();
        this.props.logOutUser((respose) => {
            this.disableLogin();
            if (respose) {
                if (respose.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    logout(() => {
                        window.location.href = '/';
                    });
                } else {
                    this.props.showNotification(respose.message, 'error');
                    return;
                }
            } else {
                this.props.showNotification(
                    'Something went wrong, Please try again later',
                    'error'
                );
                return;
            }
        });
    }

    /**
     * Handle Invoke profile details
     */
    inkoveMyProfile() {
        this.props.getUserInformation((userInfo) => {
            if (userInfo) {
                this.props.history.push(
                    `${PATH.IM_PATIENT.MY_PROFILE}/${this.props.match.params.userId}`
                );
            } else {
                this.props.showNotification(RESPONSE_CONSTANT.TRYAGAIN, RESPONSE_CONSTANT.ERROR);
            }
        });
    }

    opened = (value) => {
        this.setState({ notificationOpened: value });
    };

    handleLogout = () => {
        this.setState({ showLogoutConfirmation: true });
    };

    handleConfirmLogout = () => {
        this.inkoveSignOut();
        this.setState({ showLogoutConfirmation: false });
    };

    handleCancelLogout = () => {
        this.setState({ showLogoutConfirmation: false });
    };
    /**
     * Render page
     */
    render() {
        const userDetails = this.props.userDetails;
        return (
            <header className="flex justify-between px-8 py-4 bg-UINavbar xl:justify-end">
                <button
                    className="block xl:hidden"
                    style={{ color: 'white' }}
                    onClick={() => {
                        this.props.onClickMobileNav(true);
                    }}
                >
                    <i className="text-lg far fa-align-left"></i>
                </button>
                <div className="flex gap-4">
                    <Menu>
                        <Menu.Button className="relative z-0 p-2 bg-black rounded-lg">
                            <i className="text-white far fa-bell fa-lg"></i>
                            {this.state.notificationCount > 0 && (
                                <span className="bell-circle">{this.state.notificationCount}</span>
                            )}
                        </Menu.Button>
                        <Menu.Items className="absolute z-10 bg-[#181B22] text-white sm:w-auto notify-popup h-auto top-14 sm:p-6 p-4 rounded-lg shadow-lg border-black-10 sm:right-20 right-2 origin-top-right">
                            <NotificationPopUp
                                opened={this.opened}
                                history={this.props.history}
                                openModal={this.state.isOpenSwitch}
                                role={userDetails.role}
                                // clickedNotification={this.clickedNotification}
                                closeModel={() => {
                                    this.setState({ isOpenSwitch: false });
                                }}
                                text="Enable Verification"
                                notificationUnreadCount={this.props.notificationUnreadCount}
                                getnotificationCount={() => this.getnotificationCount()}
                            />
                        </Menu.Items>
                    </Menu>
                    {/* <div className="relative">
            <Menu>
              <Menu.Button className="z-0 p-2 bg-black rounded-lg pointer-events-none">
                <div className="flex items-center gap-2">
                  <span className="flex items-center justify-center w-8 h-8 gap-2 overflow-hidden rounded-full">
                    <img
                      src={userDetails.image ? userDetails.image : profileImg}
                      alt=""
                      srcSet=""
                      className="w-full h-full"
                    />
                  </span>
                  <div
                    className="text-white table-ellipse"
                    title={userDetails.name}
                  >
                    {userDetails.name}
                  </div>
                  {/* <i
                    className="text-white far fa-angle-down"
                    aria-hidden="true"
                  ></i> */}
                    {/* </div> */}
                    {/* </Menu.Button>
              <Menu.Items className="absolute z-10 w-full right-0 p-2 origin-top-right rounded-lg bg-[#181B22] shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none transform opacity-100 scale-100 flex flex-col">
                {/* <Menu.Item>
                  <div className="flex items-center gap-4 px-4 py-2">
                    <div className="overflow-hidden rounded-full h-9 w-9">
                      <img
                        src={userDetails.image ? userDetails.image : profileImg}
                        alt=""
                        srcSet=""
                        className="w-full h-full"
                      />
                    </div>
                    <div className="flex flex-col text-black">
                      <p
                        className="m-0 table-ellipse"
                        title={`${userDetails.firstName} ${userDetails.lastName}`}
                      >{`${userDetails.firstName} ${userDetails.lastName}`}</p>
                      <p
                        className="m-0 truncate text-muted w-52"
                        title={userDetails.email}
                      >
                        {userDetails.email}
                      </p>
                    </div>
                  </div>
                </Menu.Item> */}
                    {
                        /* {!this.props.name ? ( */
                        // <Menu.Item>
                        //   <div
                        //     className="flex items-center gap-2 px-4 py-2 text-white cursor-pointer"
                        //     onClick={() => this.inkoveMyProfile()}
                        //   >
                        //     <svg
                        //       width="16"
                        //       height="16"
                        //       viewBox="0 0 16 16"
                        //       fill="none"
                        //       xmlns="http://www.w3.org/2000/svg"
                        //     >
                        //       <path
                        //         d="M8.10664 7.24683C8.03998 7.24016 7.95998 7.24016 7.88664 7.24683C6.29998 7.1935 5.03998 5.8935 5.03998 4.2935C5.03998 2.66016 6.35998 1.3335 7.99998 1.3335C9.63331 1.3335 10.96 2.66016 10.96 4.2935C10.9533 5.8935 9.69331 7.1935 8.10664 7.24683Z"
                        //         stroke="white"
                        //         strokeWidth="1.125"
                        //         strokeLinecap="round"
                        //         strokeLinejoin="round"
                        //       />
                        //       <path
                        //         d="M4.77335 9.7065C3.16002 10.7865 3.16002 12.5465 4.77335 13.6198C6.60669 14.8465 9.61336 14.8465 11.4467 13.6198C13.06 12.5398 13.06 10.7798 11.4467 9.7065C9.62002 8.4865 6.61335 8.4865 4.77335 9.7065Z"
                        //         stroke="white"
                        //         strokeWidth="1.125"
                        //         strokeLinecap="round"
                        //         strokeLinejoin="round"
                        //       />
                        //     </svg>
                        //     Profile
                        //   </div>
                        // </Menu.Item>
                        // ) : null
                    }
                    {/* <hr className="border-[#34373E]" />
                <Menu.Item>
                  <div
                    className="flex items-center gap-2 px-4 py-2 text-white cursor-pointer"
                    onClick={this.handleLogout}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.6266 9.74659L13.3333 8.03992L11.6266 6.33325"
                        stroke="white"
                        strokeWidth="1.125"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M6.50665 8.04004H13.2867"
                        stroke="white"
                        strokeWidth="1.125"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.83999 13.3334C4.89332 13.3334 2.50665 11.3334 2.50665 8.00008C2.50665 4.66675 4.89332 2.66675 7.83999 2.66675"
                        stroke="white"
                        strokeWidth="1.125"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Logout
                  </div>
                </Menu.Item> */}
                    {/* </Menu.Items> */}
                    {/* </Menu> */}
                    {/* </div> */}
                </div>
                {this.state.showLogoutConfirmation && (
                    <LogoutConfirmation
                        onConfirm={this.handleConfirmLogout}
                        onCancel={this.handleCancelLogout}
                    />
                )}
            </header>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.UserReducer.userDetails,
        notificationUnreadCount: state.AdminNotificationReducer.notificationDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        logOutUser: (callback) => {
            dispatch(logOutUser(callback));
        },
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
        getUserInformation: (callback) => {
            dispatch(getUserInformation(callback));
        },
        notificationCount: (callback) => {
            dispatch(notificationCount(callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);

